import { AttributesStore } from './AttributesStore';
import * as API from "../services/api/api";
import { unflatten } from '../services/utils';
import {
  setActions,
  setBadges,
  setCanUseAPI,
  setColor,
  setHideAllBtn,
  setChannels,
  setFlashcard,
  setIsFrameOpened,
  setLanguage,
  setIsLoaderHidden,
  setGeneralData,
  setItemsVisibility,
  setLogo,
  setMediaMobileWidth,
  setOffsetX,
  setOffsetY,
  setPosition,
  setStyleTemplate,
  setWidgetVersion,
  setTranslations
} from './Actions'
import { flushCallback, registerCallback } from '../services/callbacks.service'

const manager = {
  createApi: createApi,
  getStoredAttribute: getStoredAttribute,
  liftAll: liftAll,
  hideLoader: hideLoader,
  goToChannel: goToChannel,
  onNotify: dispatchAction(setBadges),
  setActions: dispatchAction(setActions),
  sendResponseResult: sendResponseResult,
  setColor: dispatchAction(setColor),
  setOffsetX: dispatchAction(setOffsetX),
  setOffsetY: dispatchAction(setOffsetY),
  setPosition: dispatchAction(setPosition),
  setLogo: dispatchAction(setLogo),
  setMediaMobileWidth: dispatchAction(setMediaMobileWidth),
  setChannels: dispatchAction(setChannels),
  setCanUseAPI: dispatchAction(setCanUseAPI),
  setFlashcard: dispatchAction(setFlashcard),
  setFrameVisivility: setFrameVisivility,
  setGeneralData: dispatchAction(setGeneralData),
  hideAll: hideAll,
  setHideAllBtn: dispatchAction(setHideAllBtn),
  setItemsVisibility: dispatchAction(setItemsVisibility),
  setLanguage: dispatchAction(setLanguage),
  setStyleTemplate: dispatchAction(setStyleTemplate),
  setNewLocation: setNewLocation,
  setWidgetVersion: dispatchAction(setWidgetVersion),
  setFlattenedTranslation: setFlattenedTranslation,
  setTranslations: dispatchAction(setTranslations),
  setItemsOrder: dispatchActionByType('setItemsOrder'),
  setCallback: setCallback,
  onChatEnd: onChatEnd,
  onChatStart: onChatStart
};

export default manager;

let api = null;

function createApi(frame) {
  return api = API.create(frame, AttributesStore);
}

// dispach action using action creator
function dispatchAction(actionCreator) {
  return function (value) {
    AttributesStore.dispatch(actionCreator(value));
  }
}

// dispatch action using only action name
function dispatchActionByType(type) {
  return function (payload) {
    AttributesStore.dispatch({ type: type, payload: payload });
  }
}

function getStoredAttribute(key) {
  return api.getStoredAttribute(key);
}

function goToChannel(channel) {
  switch (channel) {
    case 'audio':
    case 'call':
      return goToChat('audio');
    case 'chat':
      return goToChat();
    case 'mail':
      return goToMail();
    case 'video':
      return goToChat('video');
  }
}

function setNewLocation(params) {
  if (!api) {
    return;
  }

  api.sendRpcEvent('onLocationChanged', params);
}

function goToChat(mode) {
  api.goToChat(mode);
  setFrameVisivility(true);
}

function goToMail() {
  api.goToMail();
  setFrameVisivility(true);
}

function setFrameVisivility(value) {
  AttributesStore.dispatch(setIsFrameOpened(value));
  api.sendRpcEvent('visibilityChange', { visible: value });
}

function hideLoader(isLoaderHidden) {
  dispatchAction(setIsLoaderHidden)(isLoaderHidden);
  if (isLoaderHidden) {
    // hide frame component if it is opened
    manager.setFrameVisivility(false);
  }
}

function liftAll() {
  api.sendRpcEvent('liftAll');
}

function hideAll() {
  api.sendRpcEvent('hideAll');
}

function sendResponseResult(data, result) {
  api.sendResponseResult(data, result);
}

function setCallback(event, cb) {
  registerCallback(event, cb);
}

function onChatEnd() {
  flushCallback('onChatEnd');
}

function onChatStart() {
  flushCallback('onChatStart');
}

/**
 *
 * @param {Object} value - flattened keys { en: { 'LOADER.TITLE: 'sample title' } }
 *
 * @returns {Object} - unflattened keys { en: { LOADER: { TITLE: 'sample title' } } }
 */
function setFlattenedTranslation(value) {
  const translations = {};

  Object.keys(value || {}).forEach(function (key) {
    translations[key] = unflatten(value[key]);
  });

  manager.setTranslations(translations);
}
